import {Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-custom-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-modal.component.html'
})
export class CustomModalComponent implements AfterViewInit {
  @Input() modalId!: string;
  @Input() title: string = 'Confirmation';
  @Input() message: string = 'Are you sure?';
  @Input() confirmButtonText: string = 'Confirm';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() showConfirmOnly: boolean = false;
  @Input() dismissible: boolean = true;

  @Output() onCloseModel  = new EventEmitter<boolean>(); // NOSONAR
  // Fires whenever the modal finishes hiding, however it was closed (buttons, header X, or a forced hide)
  @Output() modalHidden = new EventEmitter<void>();

  @ViewChild('modalRef', { static: true }) modalRef!: ElementRef;
  private modalInstance!: Modal;

  ngAfterViewInit() {
    this.modalInstance = new Modal(this.modalRef.nativeElement, {
      backdrop: 'static',
      keyboard: false // Optional: disables closing with ESC key
    });
    this.modalRef.nativeElement.addEventListener('hidden.bs.modal', () => this.modalHidden.emit());
  }

  showModal() {
    this.modalInstance?.show();
  }

  hideModal() {
    this.modalInstance?.hide();
  }

  onConfirm() {
    this.onCloseModel.emit(true);
    this.hideModal();
  }

  onCancel() {
    this.onCloseModel.emit(false);
    this.hideModal();
  }
}
